



















































import { Vue, Component, Watch } from 'vue-property-decorator';
import LessonListSearchPanel, { SearchCondition } from './ui/LessonListSearchPanel.vue';
// import ListCell from './ListCell.vue';
import { LessonListDTO } from '../../../src_server/entity/dto/LessonListDTO';
import { TeacherService } from '../../biz/remote/TeacherService';
import { Session } from '../../utils/Session';
import { MessageDialog } from '../../utils/MessageDialog';
import TeacherMovieCard from './ui/TeacherMovieCard.vue';
import TeacherProfielCard from './ui/TeacherProfielCard.vue';
import ProfileDialog from './dialog/ProfileDialog.vue';
import { FavoritTeacherService } from '../../biz/remote/FavoritTeacherService';
import LessonCalendarDialog from './dialog/LessonCalendarDialog.vue';
import LessonMessageDialog from '../../components/messages/LessonMessageDialog.vue';

@Component({
  components: {
    LessonListSearchPanel,
    TeacherMovieCard,
    TeacherProfielCard,
    ProfileDialog,
    LessonCalendarDialog,
    LessonMessageDialog,
  },
})
export default class StudentLessonListPage extends Vue {
  private originalList: LessonListDTO[] = [];
  private condition?: SearchCondition = new SearchCondition();

  private loading = false;

  /**
   * 学年のマッチング
   */
  isMatcheYear(i: LessonListDTO) {
    let result = true;
    if (this.condition?.school_year && i.teacher?.target_school_year) {
      const has = i.teacher?.target_school_year.split(',').includes(this.condition.school_year);
      result = has;
    }
    return result;
  }

  /**
   * 科目のマッチング
   */
  isMatchSubject(i: LessonListDTO) {
    let result = true;
    if (this.condition?.subject && this.condition?.subject.length > 0) {
      if (!i.teacher?.subject) {
        result = true;
      } else {
        // 先生の科目はカンマ区切り複数入ってる場合がある
        const teacherSubjects = i.teacher?.subject.split(',');
        const has = teacherSubjects.map((teacherSub) => {
          return this.condition?.subject.includes(teacherSub);
        });
        result = has.some((i) => i);
      }
    }
    return result;
  }

  /**
   * タイプのマッチング
   */
  isMatchDeafnessType(i: LessonListDTO) {
    let result = true;
    if (i.communicate?.hearing_type && this.condition?.deafness && this.condition?.deafness.length > 0) {
      result = this.condition?.deafness.includes(i.communicate.hearing_type);
    }
    return result;
  }

  /**
   * 曜日のマッチング
   */
  isMatchWeekDay(i: LessonListDTO) {
    let result = true;
    if (this.condition?.day_of_week && this.condition?.day_of_week.length > 0 && i.teacher?.work_day_of_week) {
      const weeks = this.condition.day_of_week;

      let has = true;
      const includesDoW = (day: string) => {
        const teacher_work_day = i.teacher?.work_day_of_week || '';
        const hasSeache = weeks.includes(day);
        // 条件に含まれていなければTrue
        if (!hasSeache) return true;

        // 条件に含まれていれば、先生の設定に入っているか
        return teacher_work_day.indexOf(day) > -1;
      };
      console.log('do', this.condition?.day_of_week, i.teacher?.work_day_of_week);
      has = has && includesDoW('月');
      has = has && includesDoW('火');
      has = has && includesDoW('水');
      has = has && includesDoW('木');
      has = has && includesDoW('金');
      has = has && includesDoW('土');
      has = has && includesDoW('日');

      result = has;
    }
    return result;
  }

  isMatchHandSign(i: LessonListDTO) {
    // console.log(i.communicate?.corresponding_sign_language);
    // console.log(this.condition?.handSign);

    let result = true;
    const usefull: string[] = ['Fluently', 'CanBeUsed'];

    // console.log('音声対話', this.condition?.handSign, i.communicate?.actor_type, i.communicate?.hearing_type);
    // 音声対話は、聴者をヒットさせる　聴者以外の人は、発音についての得意さを上位２つの項目なら入れる（'Fluently'：得意, 'CanBeUsed':どちらかといえば得意）
    if (this.condition?.handSign && this.condition?.handSign.includes('音声対話')) {
      if (i.communicate?.hearing_type === 'Listener') {
        result = result && true;
      } else {
        if (i.communicate?.pronunciation) {
          result = ['Fluently', 'CanBeUsed'].includes(i.communicate.pronunciation);
        } else {
          result = result && false;
        }
      }
    }
    console.log('condition ', this.condition?.now_available, i.teacher?.now_available);
    if (this.condition?.now_available) {
      result = result && i.teacher?.now_available ? true : false;
    }

    // if (this.condition?.handSign && this.condition?.handSign.includes('日本手話') && i.communicate?.sign_language) {
    //   const has = usefull.includes(i.communicate?.sign_language);
    //   result = result && has;
    // }
    // if (this.condition?.handSign && this.condition?.handSign.includes('日本語対応手話') && i.communicate?.corresponding_sign_language) {
    //   const has = usefull.includes(i.communicate?.corresponding_sign_language);
    //   result = result && has;
    // }
    return result;
  }

  isFavorite(i: LessonListDTO) {
    let result = true;
    if (this.condition?.favorite === true) {
      result = i.favorite;
    }
    return result;
  }

  get teacherList() {
    return this.originalList.filter((i) => {
      let result = true;
      Session.set<SearchCondition>('TEACHER_SEARCH_CONDITION', this.condition!);

      // 予約ページに表示するかどうかのフラグを見る
      result = result && (i.teacher?.is_show_reservation_page ? true : false);

      // 対象とする学年をフィルタリング
      result = result && this.isMatcheYear(i);

      // 対象とする科目をフィルタリング
      result = result && this.isMatchSubject(i);

      // タイプをフィルタリング
      result = result && this.isMatchDeafnessType(i);

      // 手話タイプをフィルタリング
      result = result && this.isMatchHandSign(i);

      // 曜日のフィルタリング
      result = result && this.isMatchWeekDay(i);

      // お気に入りのフィルタリング
      result = result && this.isFavorite(i);

      return result;
    });
  }

  /**
   * レッスン予約カレンダーを開く
   */
  showReservationCalendar(dto: LessonListDTO) {
    const dialog: LessonCalendarDialog = this.$refs['LessonCalendarDialog'] as LessonCalendarDialog;
    if (!dto.teacher?.user_id) {
      MessageDialog.systemError('先生のユーザーID', '予約リクエスト時', dto.teacher?.user_id);
      return;
    }
    dialog.show(dto.teacher?.user_id);
  }

  conditionChange(value: any) {
    console.log('conditionChange', value, value.subject, value.school_year, value.day_of_week, value.deafness);
    this.condition = value;
  }

  async loadData() {
    console.log('loadData');
    const biz = new TeacherService();
    const user_id = Session.getSessionUserId();
    const response = await biz.getTeacherMatchingList(user_id, Session.getSessionBuildingId());

    const fbiz = new FavoritTeacherService();
    const responseFav = await fbiz.getMy(user_id);
    const favorites = responseFav.data;

    this.originalList = response.data;

    // お気に入り結果と一覧をマージ
    this.originalList = this.originalList.map((i) => {
      // Favoriteに入っていればTrue
      i.favorite =
        !!favorites.find((value) => {
          return value.teacher_user_id === i.teacher?.user_id;
        }) || false;
      return i;
    });
  }

  showProf(dto: LessonListDTO) {
    let dialog = this.$refs['prof_dialog'] as ProfileDialog;
    dialog.showByDto(dto);
  }

  async setFavorite(dto: LessonListDTO) {
    const biz = new FavoritTeacherService();
    if (!dto.teacher?.user_id) {
      await MessageDialog.systemError('先生のユーザーID', 'お気に入り追加時', dto.teacher?.user_id);
      return;
    }

    if (!origin) {
      await MessageDialog.systemError('元の先生データ', 'お気に入り追加時', dto.teacher?.user_id);
      return;
    }

    if (dto.favorite === true) {
      await biz.delete(Session.getSessionUserId(), dto.teacher.user_id);
    } else {
      await biz.add(Session.getSessionUserId(), dto.teacher.user_id);
    }
    this.originalList = this.originalList.map((value) => {
      if (value.teacher?.user_id === dto.teacher?.user_id) {
        value.favorite = !value.favorite;
      }
      return value;
    });
  }

  async showLessonMessageDialog(teacher_user_id: string) {
    (this.$refs['LessonMessageDialog'] as LessonMessageDialog).show(teacher_user_id, Session.getSessionUserId());
  }

  mounted() {
    let condition = Session.get<SearchCondition>('TEACHER_SEARCH_CONDITION');
    if (condition) {
      console.log('load condition', condition);
      this.condition = condition;
    }
  }

  created() {
    this.loading = true;
    this.loadData().then(() => (this.loading = false));
  }
}
